import { useCheckoutStore } from "@/store/checkout";
import { useClientStore } from "@/store/client";
import { useMagasinStore } from "@/store/magasin";
import { useDatalayerStore } from "@/store/datalayer";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";

export const pageCommanderPaiementEtAvantagesProps = () => ({
  paymentMethods: {
    type: Array,
    required: false,
    default: () => []
  },
  paymentMethodsInfos: {
    type: Object,
    required: false,
    default: null
  },
  carteCoraIsMalinPlus: {
    type: Boolean,
    required: false,
    default: false
  },
  isServiceCompatibleEuroCarrefour: {
    type: Boolean,
    required: false,
    default: false
  },
  fidelites: {
    type: Array,
    required: false,
    default: () => []
  }
})

export const usePageCommanderPaiementEtAvantages = (props) => {

  const magasinStore = useMagasinStore();
  const checkoutStore = useCheckoutStore();
  const clientStore = useClientStore();
  const datalayerStore = useDatalayerStore();

  const { trackEvent } = useInteractionDoneTracking();

  const popinCommandeRecenteVisible = ref(false)
  const popinCgvVisible = ref(false)
  const urlPaiement = ref(null)
  const modePaiement = ref(null)
  const cgvContent = ref(null)
  const messageWarning = ref(null)

  const {
    name: magasinName,
    id: magasinId,
    allowCodePromo: magasinAllowCodePromo,
    getServiceById,
    allowCarteCarrefour: magasinAllowPaymentCarteCarrefour
  } = storeToRefs(magasinStore);

  const {
    modeCommande,
    dateRetrait,
    montantTotalTtc,
    idModePaiementHabituel,
    serviceId,
    idAdresseLivraison,
    warning,
    selectedPaymentId,
    typePanier,
    id: checkoutId,
    carteCadeau,
    isCarteCarrefourPossible
  } = storeToRefs(checkoutStore);

  const {
    isPorteurCarteCora,
    isPorteurCarteMalin,
    popinAjoutCarte
  } = storeToRefs(clientStore);

  const {
    updateModePaiement,
    processAvantages,
    processPaiement,
    updateModeCommande
  } = checkoutStore;

  const { setPaymentMethod } = datalayerStore;

  const modePaiementHabituel = computed(() => {
    return props.paymentMethods.find(modePaiement => 
      parseInt(modePaiement.id) === idModePaiementHabituel.value && modePaiement.attributes.mode_paiement !== "ckdo" && modePaiement.attributes.mode_paiement !== "CRF"
    );
  })
  const modesPaiement = computed(() => {
    return props.paymentMethods.filter(modePaiement => parseInt(modePaiement.id) !== idModePaiementHabituel.value && modePaiement.attributes.mode_paiement !== "CRF");
  })
  const isAlcool = computed(() => {
    if (warning.value === null) {
      return false;
    }
    return warning.value.is_alcool;
  })
  const isDataLive = computed(() => {
    const carteCRF = props.fidelites.find(fid => fid.attributes.sous_type === "CRF");
    
    return carteCRF?.attributes?.is_data_live ?? false;

  })
  const tirelire = computed(() => {
    if (modePaiement.value && props.fidelites.length > 0) {
      const fideliteCora = props.fidelites.find(fid => fid.attributes.type_carte === "cora");
      const fideliteMalin = props.fidelites.find(fid => fid.attributes.type_carte === "malin");

      if (
        fideliteCora &&
        (
          modePaiement.value.attributes.mode_paiement === "cora" ||
          (fideliteCora.attributes.sous_type === "CP" && parseFloat(fideliteCora.attributes.solde_euro) > 0)
        )
      ) {
        return {
          montant: fideliteCora.attributes.solde_euro,
          carte: fideliteCora.id,
          type: fideliteCora.attributes.sous_type === "CP" ? "Malin+" : fideliteCora.attributes.type_carte
        }
      } else if (fideliteMalin) {
        return {
          montant: fideliteMalin.attributes.solde_euro,
          carte: fideliteMalin.id,
          type: fideliteMalin.attributes.type_carte
        }
      }
    }
    return null;
  })
  const serviceHasReservationEuroCora = computed(() => {
    const service = getServiceById.value(serviceId.value);
    return service ? service.reservation_eurocora : false;
  })
  const cgvLink = computed(() => {
    if (typePanier.value === "click_and_collect_traiteur_noel") {
      return "/legal/informations-juridiques/conditions-generales-de-vente-traiteur-de-fetes"
    }
    return "/legal/informations-juridiques/conditions-generales-de-vente-coradrive"
  })

  const modePaiementSelected = async (pm) => {
    selectedPaymentId.value = pm.id;
    setPaymentMethod(pm.attributes.mode_paiement)
    modePaiement.value = pm;
    await updateModePaiement({
      modePaiement: pm.id
    });
    try {
      const res = await processAvantages();
      if (res.meta && res.meta.message_warning) {
        messageWarning.value = res.meta.message_warning;
        trackEvent({
          event: trackingCodes.CATEGORYGA.popinErreur,
          pageType: trackingCodes.PAGETYPE.tunnel,
          categoryGA: trackingCodes.CATEGORYGA.popinErreur,
          actionGA: trackingCodes.EVENTS.affichageErreur,
          labelGA: res.meta.message_warning
        });
      }
    } catch { }
  }

  const paiement = async (params = {}) => {
    if ((params.tirelire && params.tirelire.montant > 0) ||
      (params.alias_paiement_id && params.alias_paiement_id !== null)) {
      try {
        await updateModeCommande(params);
      } catch (err) {
        return;
      }
    }
    try {
      const data = await processPaiement();
      urlPaiement.value = data.url_webview_paiement;
      if (data.warning && data.warning.commande_recente) {
        popinCommandeRecenteVisible.value = true;
      } else {
        redirectToPaiement();
      }
    } catch (err) {

    }
  }
  const updateTirelire = async (tirelire) => {
    try {
      await updateModeCommande({
        tirelire
      });
    } catch (err) { }
  }
  const setPopinCommandeRecenteVisible = (visible) => {
    popinCommandeRecenteVisible.value = visible;
  }
  const setPopinCgvVisible = (visible) => {
    popinCgvVisible.value = visible;
  }
  const redirectToPaiement = () => {
    window.location.href = urlPaiement.value;
  }

  return {
    popinCommandeRecenteVisible,
    popinCgvVisible,
    urlPaiement,
    modePaiement,
    cgvContent,
    messageWarning,
    magasinName,
    magasinId,
    magasinAllowCodePromo,
    getServiceById,
    magasinAllowPaymentCarteCarrefour,
    modeCommande,
    dateRetrait,
    montantTotalTtc,
    idModePaiementHabituel,
    serviceId,
    idAdresseLivraison,
    warning,
    typePanier,
    checkoutId,
    isPorteurCarteCora,
    isPorteurCarteMalin,
    popinAjoutCarte,
    updateModePaiement,
    processAvantages,
    processPaiement,
    updateModeCommande,
    setPaymentMethod,
    modePaiementHabituel,
    modesPaiement,
    isAlcool,
    tirelire,
    serviceHasReservationEuroCora,
    cgvLink,
    carteCadeau,
    isCarteCarrefourPossible,
    modePaiementSelected,
    paiement,
    updateTirelire,
    setPopinCommandeRecenteVisible,
    setPopinCgvVisible,
    redirectToPaiement,
    isDataLive
  }
}